module.exports = __webpack_public_path__ + "img/win_item18.3b0e5d1a.png";